import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-object',
  templateUrl: './confirm-object.html',
  styleUrls: ['./confirm-object.css'],
  standalone: false
})
export class ConfirmObjectDialog extends DialogBase implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmObjectDialog>,
    @Inject(MAT_DIALOG_DATA) public data) {
    super("ConfirmObjectDialog");

  }
  async ngOnInit() {
  }
  public cancel() {
    this.dialogRef.close(false);
  }
  public confirm() {
    this.dialogRef.close(true);
  }
}
